import axios from 'axios'

import { _getAppLang, API } from '@utils'
import { getPublicLibraryBaseUrl } from './public-library/public-libraries-utilities'
import { store } from '@csrc/redux/storeConfig/store'

const baseConfig = {
  ...API.defaults,
  headers: {
    ...API.defaults.headers,        // pull in all original headers
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*"
  },
  withCredentials: false,
  timeout: 2 * 60 * 1000
}

const PublicLibraryAPIInstance = axios.create(baseConfig)

PublicLibraryAPIInstance.interceptors.request.use((config) => {
  config.baseURL = getPublicLibraryBaseUrl()
  return config
})

// Copy over the interceptors from API → PublicLibraryAPI
// @ts-ignore
API.interceptors.request.handlers.forEach(h => PublicLibraryAPIInstance.interceptors.request.use(h.fulfilled, h.rejected))
// @ts-ignore
API.interceptors.response.handlers.forEach(h => PublicLibraryAPIInstance.interceptors.response.use(h.fulfilled, h.rejected))

const PublicLibraryAPI = () => {
  const lang = _getAppLang()
  PublicLibraryAPIInstance.defaults.headers['Accept-Language'] = lang
  return PublicLibraryAPIInstance
}

export { PublicLibraryAPI }

